import { makeResetStyles, shorthands, tokens } from '@fluentui/react-components';

export const useStyles = makeResetStyles({
  display: 'flex',
  flexDirection: 'row',
  height: '100%',
  width: '100%',
  ...shorthands.overflow('hidden'),
  '& .card': {
    height: 'fit-content',
    ...shorthands.padding('16px', '16px', '32px', '16px'),
  },
  '& .button': {
    paddingLeft: '0px',
  },
  '& .placement-preview-text-wrapper': {
    marginTop: '8px',
    marginBottom: '8px',
  },
  '& .placement-preview-text': {
    display: 'flex',
    fontSize: '12px',
    lineHeight: '16px',
    fontWeight: 600,
    color: tokens.colorNeutralForeground1,
    ...shorthands.padding('4px'),
    ...shorthands.gap('2px'),
    backgroundColor: tokens.colorNeutralBackground5,
    ...shorthands.borderRadius('4px'),
    width: 'fit-content',
  },
});
